<script lang="ts">
  import ImageRender from './ImageRender.svelte';

  export let src: string | null | undefined;
  export let alt = '';
  export let seed = '';
</script>

<div class="octagon relative aspect-square w-full rotate-[30deg] overflow-hidden {$$props.class}">
  <ImageRender src={src ?? undefined} {alt} {seed} imgClass="-rotate-[30deg]" />
</div>

<style>
  .octagon {
    /* TODO better clip path */
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
  }
</style>
